import EmployeeService from '../../services/employee.service';

const updateEmployee = async (employeeData) => {
    try {
        return await EmployeeService.update(employeeData);
    } catch (error) {
        console.error('Error updating employee:', error.response ? error.response.data : error.message);
        // Re-throw the error so the form can handle it
        throw error;
    }
};

export default updateEmployee;
